import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        textAlign: "center",
        padding: "5rem 1.5rem",
        backgroundColor: "#fff",
        color: "#333",
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          fontFamily: "'Dancing Script','Brush Script MT',cursive",
          fontSize: "4rem",
          color: "#ff8b3d",
          margin: "0 0 1rem",
        }}
      >
        404 - Page Not Found
      </h1>
      <p style={{ fontSize: "18px", color: "#666", marginBottom: "2rem" }}>
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          background: "#f58220",
          color: "#fff",
          padding: "12px 28px",
          textDecoration: "none",
          fontWeight: "700",
          fontSize: "14px",
          borderRadius: "4px",
        }}
      >
        Return to Home
      </Link>
    </div>
  );
}

export default NotFound;
